import { $httpFhirApi } from '@/common/api/httpFhir.service';
import { RelatedPerson } from '@/fhirworks';
import _ from 'lodash';

function getTransactionQuery(queryString) {
    queryString = encodeURI(queryString.split(' ').filter(Boolean).join('+'));
    return `RelatedPerson/$lookup?by=name.family,name.given,birthDate,identifier.value;address.city,address.line;telecom.value&sort=name.given,name.family&count=50&q=${queryString}`;
}

async function processRelatedPersonResponse(responseEntry) {
    // Process FHIR response entry and convert to RelatedPerson objects
    let returnedRelatedPersons = [];

    if (responseEntry && responseEntry.length > 0) {
        responseEntry.forEach((resultRow) => {
            const resourceData = resultRow.resource || resultRow;

            let relatedPerson = new RelatedPerson(resourceData);
            relatedPerson._group = _.get(resultRow, '_group', '');

            if (!relatedPerson.fullName && !relatedPerson.display) {
                if (relatedPerson.name && relatedPerson.name.length > 0) {
                    const name = relatedPerson.name[0];
                    const given = name.given ? name.given.join(' ') : '';
                    const family = name.family || '';
                    relatedPerson.display = `${given} ${family}`.trim();
                }
            }

            returnedRelatedPersons.push(relatedPerson);
        });
    }

    return returnedRelatedPersons;
}

export default {
    search: (queryString) => {
        queryString = encodeURI(queryString.split(' ').filter(Boolean).join('+'));

        let returnPromise = $httpFhirApi.get(
            `RelatedPerson/$lookup?by=name.family,name.given,birthDate,identifier.value;address.city,address.line;telecom.value&sort=name.given,name.family&count=50&q=${queryString}`,
        );

        return returnPromise.then((res) => {
            let returnedRelatedPersons = [];

            res.originalData.entry.forEach((resultRow) => {
                const resourceData = resultRow.resource || resultRow;

                let relatedPerson = new RelatedPerson(resourceData);
                relatedPerson._group = _.get(resultRow, '_group', '');

                if (!relatedPerson.fullName && !relatedPerson.display) {
                    if (relatedPerson.name && relatedPerson.name.length > 0) {
                        const name = relatedPerson.name[0];
                        const given = name.given ? name.given.join(' ') : '';
                        const family = name.family || '';
                        relatedPerson.display = `${given} ${family}`.trim();
                    }
                }

                returnedRelatedPersons.push(relatedPerson);
            });

            return returnedRelatedPersons;
        });
    },

    getTransactionQuery,
    processRelatedPersonResponse,
};
